import { useEffect } from 'react'
import { useSelector } from '@/libs/state'
import { customers, customerEnrichment, notify } from '../wiring'
import { cancelCustomerEnrichment } from '../application/cancel-customer-enrichment'
import { clearCustomerEnrichment } from '../application/clear-customer-enrichment'
import { deleteCustomer } from '../application/delete-customer'
import { listCustomers } from '../application/list-customers'
import { requestCustomerEnrichment } from '../application/request-customer-enrichment'
import { customerList$, customerListVersion$, refreshCustomerList } from '../store'
import { useCustomerParams } from '../ui/use-customer-params'

const useCustomersList = () => {
	const { q } = useCustomerParams()
	const customerList = useSelector(customerList$)
	const version = useSelector(customerListVersion$)

	useEffect(() => {
		listCustomers(customers, { q: q ?? null }, notify).then(result => {
			customerList$.set(result)
		})
	}, [q, version])

	const handleDelete = async (id: string): Promise<void> => {
		await deleteCustomer(customers, id, notify)
		refreshCustomerList()
	}

	const handleEnrich = async (id: string): Promise<void> => {
		try {
			await requestCustomerEnrichment(customerEnrichment, id)
			notify.success('customer.enrichRequested')
			refreshCustomerList()
		} catch {
			notify.error('customer.enrichRequestFailed')
		}
	}

	const handleCancelEnrichment = async (id: string): Promise<void> => {
		try {
			await cancelCustomerEnrichment(customerEnrichment, id)
			notify.success('customer.enrichCancelled')
			refreshCustomerList()
		} catch {
			notify.error('customer.enrichCancelFailed')
		}
	}

	const handleClearEnrichment = async (id: string): Promise<void> => {
		try {
			await clearCustomerEnrichment(customerEnrichment, id)
			notify.success('customer.enrichCleared')
			refreshCustomerList()
		} catch {
			notify.error('customer.enrichClearFailed')
		}
	}

	return {
		customerList,
		handleDelete,
		handleEnrich,
		handleCancelEnrichment,
		handleClearEnrichment,
	}
}

export { useCustomersList }
